var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.66249 1.34998C6.12926 1.34998 4.87286 2.5346 4.75845 4.0386C4.75528 4.08024 4.76961 4.12131 4.798 4.15194C4.82639 4.18257 4.86626 4.19998 4.90802 4.19998H6.19004C6.26468 4.19998 6.32796 4.1451 6.33853 4.07122C6.43122 3.42319 6.9888 2.92498 7.66249 2.92498H14.4626C15.9054 2.92498 17.0751 4.09463 17.0751 5.53748V12.3375C17.0751 13.0112 16.5769 13.5687 15.9288 13.6614C15.8549 13.672 15.8001 13.7353 15.8001 13.8099V15.0919C15.8001 15.1337 15.8175 15.1736 15.8481 15.2019C15.8787 15.2303 15.9198 15.2447 15.9614 15.2415C17.4655 15.1271 18.6501 13.8707 18.6501 12.3375V5.53748C18.6501 3.22478 16.7753 1.34998 14.4626 1.34998H7.66249Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.26262 4.74998C2.65408 4.74998 1.3501 6.05395 1.3501 7.66248V15.7375C1.3501 17.346 2.65408 18.65 4.26262 18.65H12.3377C13.9462 18.65 15.2502 17.346 15.2502 15.7375V7.66248C15.2502 6.05395 13.9462 4.74998 12.3377 4.74998H4.26262ZM2.92511 7.66248C2.92511 6.9238 3.52393 6.32498 4.26262 6.32498H12.3377C13.0764 6.32498 13.6752 6.9238 13.6752 7.66248V15.7375C13.6752 16.4762 13.0764 17.075 12.3377 17.075H4.26262C3.52393 17.075 2.92511 16.4762 2.92511 15.7375V7.66248Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.3eef122ce9b6f2b2d7f7104f37c1afd7.svg";
export { ForwardRef as ReactComponent };